// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__ul84T","sizeSm":"SegmentedControl_sizeSm__lMBmH","item":"SegmentedControl_item__CZFCx","active":"SegmentedControl_active__1WZLy"};